import CityService from '@/business/modules/city/city.service';

class CityController {
	static #instance: CityController;
	private readonly service;

	private constructor() {
		this.service = CityService.getInstance();
	}

	public static getInstance(): CityController {
		if (!CityController.#instance) {
			CityController.#instance = new CityController();
		}
		return CityController.#instance;
	}

	getCities() {
		return this.service.getCities();
	}
}

export default CityController;
